export class DevOpsActionParameter {
    name?: string;
    value?: any;
    valueCollection?: any[];
    isBoolean?: boolean;
    isNumber?: boolean;
    isString?: boolean;
}
